import React, { useEffect, useState } from "react";
import { useIntl } from "react-intl";
import classNames from "classnames";
import { useUpdateSkill } from "@/query/skill";
import { useAgentId, useModal } from "@/hook";
import Button from "@/component/Button";
import { Modal } from "@/component/modal";
import { errorToast, successToast } from "@/component/Toast";


export const SKILL_MODIFY_MODAL_ID = "skill-modify-modal-id";

const SkillModifyModal: React.FC = () => {
    const intl = useIntl();
    const modal = useModal();
    const agentId = useAgentId();
    const skill = modal.getData(SKILL_MODIFY_MODAL_ID);

    const [name, setName] = useState<string>("");
    const [validated, setValidated] = useState<boolean>(false);

    const { mutateAsync: updateSkill } = useUpdateSkill(agentId, skill?.id);

    const onClickConfirm = async () => {
        const validation = name.trim().length > 0;
        setValidated(validation);
        if (!validation) {
            return;
        }
        await updateSkill({ name: name.trim() })
            .then(() => {
                successToast(intl.formatMessage({ id: "t003" }));
                modal.close(SKILL_MODIFY_MODAL_ID);
            })
            .catch(() => {
                errorToast(intl.formatMessage({ id: "t004" }));
            });
    };

    useEffect(() => {
        setName(skill?.name || "");
    }, [skill]);

    return (
        <Modal id={SKILL_MODIFY_MODAL_ID}
               size="sm"
               title={intl.formatMessage({ id: "i03011" })}
               onClose={() => setValidated(false)}
        >
            <div className="modal-body">
                <input className={classNames(
                           "modal-input",
                           validated && !name.trim() && "input-invalid"
                       )}
                       value={name}
                       onChange={e => setName(e.target.value)}
                />
                <div className="modal-btn-group">
                    <Button size="sm"
                            variant="secondary"
                            onClick={() => modal.close(SKILL_MODIFY_MODAL_ID)}
                    >
                        {intl.formatMessage({ id: "b0002" })}
                    </Button>
                    <Button size="sm"
                            variant="primary"
                            onClick={onClickConfirm}
                    >
                        {intl.formatMessage({ id: "b0001" })}
                    </Button>
                </div>
            </div>
        </Modal>
    );
};

export default SkillModifyModal;
